const BATCH_SIZE = 20;
const FLUSH_INTERVAL = 30000;
const MAX_BUFFER = 100;

let buffer = [];
let sessionId = null;
let flushTimer = null;
let planId = null;
let getScale = null;
let getLevel = null;
let unloadListenerAttached = false;

function generateSessionId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}

function getDeviceType() {
    if (typeof window === 'undefined') return 'unknown';
    const w = window.innerWidth;
    if (w < 768) return 'phone';
    if (w < 1024) return 'tablet';
    return 'desktop';
}

function pushEvent(gestureType, extra = {}) {
    if (!planId) return;
    buffer.push({
        plan_id: planId,
        gesture_type: gestureType,
        level_index: getLevel ? getLevel() : 0,
        x_percent: extra.x != null ? parseFloat(extra.x) : null,
        y_percent: extra.y != null ? parseFloat(extra.y) : null,
        scale: getScale ? getScale() : null,
        device_type: getDeviceType(),
        user_agent: (navigator.userAgent || '').substring(0, 500),
        session_id: sessionId,
    });
    if (buffer.length >= BATCH_SIZE) {
        flush();
    }
}

function flush() {
    if (buffer.length === 0) return;
    const events = buffer.slice(0, BATCH_SIZE);
    buffer = buffer.slice(BATCH_SIZE);
    fetch('/api/gesture_events/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ events }),
        keepalive: true,
    }).catch(() => {
        buffer = [...events, ...buffer].slice(0, MAX_BUFFER);
    });
}

export function initGestureTracking(id, scaleGetter, levelGetter) {
    planId = id;
    if (!sessionId) {
        sessionId = generateSessionId();
    }
    getScale = scaleGetter;
    getLevel = levelGetter;

    if (flushTimer) clearInterval(flushTimer);
    flushTimer = setInterval(flush, FLUSH_INTERVAL);
    if (!unloadListenerAttached) {
        window.addEventListener('beforeunload', flush);
        unloadListenerAttached = true;
    }
}

export function destroyGestureTracking() {
    flush();
    if (flushTimer) clearInterval(flushTimer);
    flushTimer = null;
    if (unloadListenerAttached) {
        window.removeEventListener('beforeunload', flush);
        unloadListenerAttached = false;
    }
    planId = null;
    getScale = null;
    getLevel = null;
    buffer = [];
}

export function trackPinchZoomPlan() { pushEvent('pinch_zoom_plan'); }
export function trackPinchZoomImages() { pushEvent('pinch_zoom_images'); }
export function trackPanPlan() { pushEvent('pan_plan'); }
export function trackSwipeImages() { pushEvent('swipe_images'); }
export function trackTapMarker(x, y) { pushEvent('tap_marker', { x, y }); }
export function trackTapLevelTab() { pushEvent('tap_level_tab'); }
export function trackTapAgent() { pushEvent('tap_agent'); }
export function trackTapMaps() { pushEvent('tap_maps'); }
export function trackTapReadMore() { pushEvent('tap_readmore'); }
export function trackTapShare() { pushEvent('tap_share'); }
export function trackTapFeedback() { pushEvent('tap_feedback'); }
export function trackTapReset() { pushEvent('tap_reset'); }
export function trackTapCreatedBy() { pushEvent('tap_created_by'); }
export function trackTapPlan(x, y, containerEl) {
    if (!containerEl) { pushEvent('tap_plan'); return; }
    const rect = containerEl.getBoundingClientRect();
    pushEvent('tap_plan', {
        x: ((x - rect.left) / rect.width * 100).toFixed(2),
        y: ((y - rect.top) / rect.height * 100).toFixed(2),
    });
}
